import { render, staticRenderFns } from "./WXCW81YSSJ.vue?vue&type=template&id=4ef88e32&scoped=true&"
import script from "./WXCW81YSSJ.vue?vue&type=script&lang=js&"
export * from "./WXCW81YSSJ.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef88e32",
  null
  
)

export default component.exports